import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
    Icon,
    ModalAdapter,
    ModalContainer,
    ModalHeader,
} from "@malirang/front-share";

@Component({
    selector: "app-completeness-guide",
    templateUrl: "./completeness-guide.modal.html",
    styleUrls: ["./completeness-guide.modal.css"],
    imports: [CommonModule, ModalHeader, ModalContainer, Icon],
})
export class CompletenessGuideModal extends ModalAdapter {}
